window.SwiperLoader = (function createSwiperLoader() {
  let scriptPromise = null;

  const loadSwiper = (src) => {
    if (scriptPromise) return scriptPromise;

    scriptPromise = new Promise((resolve, reject) => {
      if (window.Swiper) {
        resolve(window.Swiper);
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve(window.Swiper);
      script.onerror = () => reject(new Error(`Unable to load ${src}`));
      document.head.appendChild(script);
    });

    return scriptPromise;
  };

  const onVisible = async (element, src, callback) => {
    if (!element) return;

    const initialise = async () => {
      try {
        const Swiper = await loadSwiper(src);
        callback(Swiper);
      } catch (error) {
        console.error('Swiper failed to initialise', error);
      }
    };

    if (!('IntersectionObserver' in window)) {
      await initialise();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        initialise();
      },
      { rootMargin: '400px' }
    );

    observer.observe(element);
  };

  return { onVisible };
})();
